import images from "~/assets/images";

/**
 * Avatar mặc định theo chức vụ + giới tính (chưa có chức năng upload avatar).
 * gender 'female' → ảnh nữ, còn lại (male/other/trống) → ảnh nam.
 * Role lạ / root / admin → tạm dùng ảnh giáo vụ.
 */
export function resolveUserAvatar(user) {
	const isWoman = user?.gender === 'female';

	switch (user?.role) {
		case 'teacher':
			return isWoman ? images.womanTeacher : images.manTeacher;
		case 'student':
			return isWoman ? images.womanStudent : images.manStudent;
		case 'parent':
			return isWoman ? images.womanParent : images.manParent;
		case 'academic':
		default:
			return isWoman ? images.womanAcademic : images.manAcademic;
	}
}
